import Icon from "@/components/Icon";
import ListItem from "@/components/ListItem";
import Progress from "@/components/Progress";
import type { StepStatus } from "@/providers/ProcessTrackerProvider";

function ProcessStepIcon({ status }: { status: StepStatus }) {
  switch (status) {
    case "pending":
      return <Icon name="check_circle" size={24} className="text-sys-brand-on-surface-variant opacity-20" />;
    case "processing":
      return <Progress size={24} activeIndicatorWidth={16} />;
    case "complete":
      return <Icon name="check_circle" size={24} filled className="text-extended-success-brand-color" />;
    case "error":
      return <Icon name="error" size={24} filled className="text-sys-brand-error" />;
  }
}

type Props = {
  status: StepStatus;
  headline: string;
  supportingText?: string;
  bordered?: boolean;
  testId?: string;
  variant?: "default" | "subtle";
};

export default function ProcessStepLineItem({
  status,
  headline,
  supportingText,
  bordered = false,
  testId,
  variant = "default"
}: Props) {
  const lineItem = (
    <ListItem
      compact
      leading={
        <div className="flex items-center justify-center w-6 h-6 flex-shrink-0">
          <ProcessStepIcon status={status} />
        </div>
      }
      headline={
        variant === "subtle" ? <span className="text-body-large font-normal italic">{headline}</span> : headline
      }
      supportingText={supportingText}
    />
  );

  if (!bordered) return lineItem;

  return (
    <div className="rounded-lg border border-sys-brand-outline p-3" data-testid={testId} data-step-status={status}>
      {lineItem}
    </div>
  );
}
